import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { useContact } from "../App";

const CoreSellPage = () => {
  const contact = useContact();
  const [activeTab, setActiveTab] = useState("stock");
  const [activeScreenshot, setActiveScreenshot] = useState(0);

  const screenshots = [
    {
      title: "داشبورد اصلی و مانیتورینگ بلادرنگ",
      desc: "نمای کلی وضعیت صف‌های پردازشی، اتصال وب‌هوک و سلامت تبادلات",
      image: "./image/coresell1.jpg",
    },
    {
      title: "هماهنگی موجودی و کانال‌های فروش",
      desc: "کنترل موجودی چندسطحی، تنوع‌های رنگ و سایز و وب‌هوک دیجی‌کالا و باسلام",
      image: "./image/coresell2.jpg",
    },
    {
      title: "انبار مرکزی و قیمت‌گذاری درصدی",
      desc: "انبارگردانی دسته‌ای با فایل اکسل و تنظیم اتوماتیک درصد کمیسیون مارکت‌پلیس‌ها",
      image: "./image/coresell3.jpg",
    }
  ];

  const highlights = [
    "حاصل ۷ ماه تحقیق و توسعه مهندسی مستمر در استودیو آلتو",
    "همگام‌سازی ثانیه‌ای موجودی با دیجی‌کالا، باسلام و سایت شخصی",
    "قیمت‌گذاری هوشمند درگاه‌ها بر اساس درصد کمیسیون و کارمزد",
    "حذف قطعی جریمه‌های لغو سفارش ناشی از اتمام موجودی",
    "انبارداری دسته‌ای و به‌روزرسانی هزاران قلم کالا با فایل اکسل",
    "افزونه اختصاصی ووکامرس برای اتصال دوطرفه به سایت‌های وردپرسی",
    "معماری فوق‌مقاوم مبتنی بر صف‌های توزیع‌شده (BullMQ / Redis)",
  ];

  const modules = [
    {
      id: "stock",
      label: "همگام‌سازی موجودی",
      title: "کسر آنی موجودی در تمام کانال‌ها",
      desc: "به محض اینکه مشتری در دیجی‌کالا، باسلام یا سایت خرید کند، موجودی همان کالا با احتساب رنگ و سایز در کمتر از یک ثانیه در سایر فروشگاه‌ها کاهش می‌یابد تا کالای ناموجود فروخته نشود.",
      bullets: [
        "وب‌هوک لحظه‌ای دریافت سفارش و کسر خودکار",
        "پشتیبانی از تنوع چندسطحی: رنگ، سایز، گارانتی و شناسه فنی (SKU)",
        "امکان تعیین موجودی رزرو یا حد آستانه هشدار ناموجودی",
        "پیشگیری صددرصدی از جریمه‌های سنگین و افت رتبه فروشندگی دیجی‌کالا",
      ],
      badge: "سرعت زیر ۱ ثانیه",
    },
    {
      id: "pricing",
      label: "قیمت‌گذاری هوشمند",
      title: "محاسبه خودکار قیمت بر اساس درصد هر درگاه",
      desc: "دیگر نیازی به باز کردن پنل‌ها و محاسبه دستی قیمت‌ها با نوسان بازار نیست. قیمت پایه محصول را در انبار مرکزی تغییر دهید؛ کورسل قیمت هر درگاه را متناسب با کمیسیون محاسبه و ارسال می‌کند.",
      bullets: [
        "تعیین درصد مجزا برای هر درگاه (مثلاً +۱۵٪ دیجی‌کالا، +۸٪ باسلام)",
        "امکان تنظیم درصد اختصاصی برای یک تنوع خاص یا به صورت سراسری",
        "ارسال مجزا و دسته‌ای قیمت‌ها بدون ایجاد تداخل با صف موجودی",
        "کلید سراسری قطع و وصل سریع قیمت‌گذاری برای کنترل ریسک بازار",
      ],
      badge: "پوشش کامل کمیسیون‌ها",
    },
    {
      id: "warehouse",
      label: "انبار مرکزی و اکسل",
      title: "انبارگردانی سریع و ورود دسته‌ای با اکسل",
      desc: "برای فروشگاه‌هایی با تنوع و اقلام بالا، مدیریت دستی غیرممکن است. با کورسل فایل اکسل موجودی انبار را بارگذاری کنید تا در چند لحظه به تمامی فروشگاه‌ها تزریق شود.",
      bullets: [
        "بارگذاری مستقیم فایل‌های اکسل موجودی انبار",
        "انبارگردانی دسته‌ای و ذخیره تاریخچه دقیق ورودی/خروجی",
        "تطبیق خودکار کالاها از روی بارکد و شناسه تنوع",
        "داشبورد جامع نظارت بر وضعیت موجودی انبار مرکزی",
      ],
      badge: "مدیریت انبوه کالاها",
    },
    {
      id: "resilience",
      label: "پایداری و درگاه‌ها",
      title: "اتصال رسمی و معماری ضدفروپاشی",
      desc: "معماری کورسل بر پایه صف‌های توزیع‌شده طراحی شده تا اختلال در اینترنت، تاخیر سرورهای واسط یا خطاهای مقطعی مانع از چرخه کار فروشگاه نشود.",
      bullets: [
        "اتصال به پنل جدید فروشندگان دیجی‌کالا با تمدید خودکار توکن و Batching",
        "سیستم خودترمیم تنوع‌های باسلام (Remap/Remove در زمان بروز خطا)",
        "افزونه اختصاصی ووکامرس برای هماهنگی سریع وردپرس",
        "پردازش مطمئن پس‌زمینه با Redis و BullMQ بدون خطر از دست رفتن داده",
      ],
      badge: "آپ‌تایم و قابلیت اطمینان بالا",
    },
  ];

  const techStack = [
    { name: "Node.js & Express", desc: "هسته مقیاس‌پذیر بک‌اند و پردازش وب‌هوک‌ها" },
    { name: "Redis & BullMQ", desc: "صف‌های توزیع‌شده و پردازش نامتقارن سفارش‌ها" },
    { name: "React & Tailwind CSS", desc: "رابط کاربری مدرن، واکنش‌گرا و سریع" },
    { name: "MongoDB", desc: "پایگاه داده اسنادی با مدل‌سازی چندتنوعی کالاها" },
    { name: "WooCommerce Plugin", desc: "افزونه وردپرس بومی جهت تبادل داده دوطرفه" },
    { name: "Docker & Nginx", desc: "زیرساخت ابری پایدار و دیپلوی خودکار CI/CD" },
  ];

  return (
    <div className="min-h-screen bg-slate-900 text-slate-100">
      <Header />

      {/* Hero Section */}
      <section className="relative pt-12 pb-20 overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 bg-gradient-to-b from-teal-500/10 via-transparent to-transparent pointer-events-none" />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 relative z-10">
          <nav className="text-sm mb-8" aria-label="مسیر راهنما">
            <ol className="flex items-center space-x-reverse space-x-2 text-slate-400">
              <li>
                <Link to="/" className="hover:text-teal-400 transition-colors">
                  خانه
                </Link>
              </li>
              <li>/</li>
              <li>
                <span className="text-slate-500">محصولات نرم‌افزاری</span>
              </li>
              <li>/</li>
              <li className="text-teal-400 font-medium">سامانه کورسل (CoreSell)</li>
            </ol>
          </nav>

          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-teal-500/10 border border-teal-500/30 text-teal-400 text-xs sm:text-sm font-medium mb-6">
              <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse" />
              <span>محصول اختصاصی آلتو استودیو · ثمره ۷ ماه توسعه مداوم</span>
            </div>

            <h1 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight mb-6 leading-tight">
              سامانه یکپارچه مدیریت موجودی و قیمت‌گذاری چندکاناله{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-cyan-400">
                کورسل (CoreSell)
              </span>
            </h1>

            <p className="text-slate-300 text-base sm:text-xl leading-relaxed mb-8">
              فروش همزمان در دیجی‌کالا، باسلام و سایت شخصی بدون ترس از ناموجودی کالا و خطای قیمت. کورسل نبض انبار و فروش آنلاین‌شاپ شما را به‌صورت خودکار و در لحظه تنظیم می‌کند.
            </p>

            <div className="flex flex-wrap justify-center gap-4">
              <a
                href={contact.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-teal-500 hover:bg-teal-400 text-slate-950 font-bold px-7 py-3.5 rounded-xl shadow-lg shadow-teal-500/25 transition-all hover:scale-105 flex items-center gap-2 text-sm sm:text-base"
              >
                <span>مشاوره و راه‌اندازی برای آنلاین‌شاپ</span>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
              <a
                href="tel:09134378347"
                className="bg-slate-800 hover:bg-slate-700 text-white font-medium px-6 py-3.5 rounded-xl border border-slate-700 transition flex items-center gap-2 text-sm sm:text-base"
              >
                <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>تماس مستقیم: ۰۹۱۳۴۳۷۸۳۴۷</span>
              </a>
            </div>
          </div>

          {/* Interactive 3-Screenshot Showcase */}
          <div className="mt-14 rounded-2xl border border-slate-700/80 shadow-2xl overflow-hidden bg-slate-950 relative">
            <div className="flex items-center justify-between px-4 py-3 bg-slate-800/80 border-b border-slate-700 text-xs text-slate-400">
              <div className="flex items-center gap-2">
                <span className="w-3 h-3 rounded-full bg-red-500/80" />
                <span className="w-3 h-3 rounded-full bg-amber-500/80" />
                <span className="w-3 h-3 rounded-full bg-emerald-500/80" />
              </div>
              <div className="flex items-center gap-2 text-xs">
                <span className="font-mono text-teal-400">CoreSell UI Showcase</span>
                <span className="text-slate-500">|</span>
                <span className="text-slate-300 font-medium">{screenshots[activeScreenshot].title}</span>
              </div>
              <span className="text-[11px] bg-teal-500/10 text-teal-400 px-2 py-0.5 rounded border border-teal-500/30">
                تصویر {activeScreenshot + 1} از ۳
              </span>
            </div>

            <div className="relative group bg-slate-900 aspect-video max-h-[520px] flex items-center justify-center overflow-hidden">
              <img
                src={screenshots[activeScreenshot].image}
                alt={screenshots[activeScreenshot].title}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = "./image/project.png";
                }}
                className="w-full h-full object-contain bg-slate-950 transition-all duration-300"
              />

              {/* Prev / Next buttons */}
              <button
                onClick={() => setActiveScreenshot((prev) => (prev > 0 ? prev - 1 : screenshots.length - 1))}
                className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-teal-600 transition-all border border-slate-700 opacity-80 group-hover:opacity-100"
                title="تصویر قبلی"
              >
                ‹
              </button>
              <button
                onClick={() => setActiveScreenshot((prev) => (prev < screenshots.length - 1 ? prev + 1 : 0))}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-slate-900/80 text-white flex items-center justify-center hover:bg-teal-600 transition-all border border-slate-700 opacity-80 group-hover:opacity-100"
                title="تصویر بعدی"
              >
                ›
              </button>
            </div>

            {/* Thumbnail Navigation */}
            <div className="p-3 bg-slate-900/90 border-t border-slate-800 grid grid-cols-1 sm:grid-cols-3 gap-2.5">
              {screenshots.map((s, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveScreenshot(idx)}
                  className={`p-2.5 rounded-xl text-right transition-all flex items-center gap-3 border ${
                    activeScreenshot === idx
                      ? "bg-teal-500/10 border-teal-500/50 shadow-md shadow-teal-500/10"
                      : "bg-slate-800/50 border-slate-700/50 hover:bg-slate-800 hover:border-slate-600"
                  }`}
                >
                  <div className="w-10 h-8 rounded bg-slate-950 overflow-hidden flex-shrink-0 border border-slate-700">
                    <img
                      src={s.image}
                      alt=""
                      onError={(e) => {
                        e.currentTarget.onerror = null;
                        e.currentTarget.src = "./image/project.png";
                      }}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className={`text-xs font-semibold truncate ${activeScreenshot === idx ? "text-teal-300" : "text-slate-300"}`}>
                      {idx + 1}. {s.title}
                    </p>
                    <p className="text-[11px] text-slate-500 truncate">{s.desc}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Metrics & Highlights */}
      <section className="py-14 bg-slate-800/40 border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
              <div className="text-3xl sm:text-4xl font-extrabold text-teal-400 font-mono">۷ ماه</div>
              <p className="text-xs sm:text-sm text-slate-400 mt-1">توسعه مهندسی مداوم</p>
            </div>
            <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
              <div className="text-3xl sm:text-4xl font-extrabold text-cyan-400 font-mono">&lt; ۱ ثانیه</div>
              <p className="text-xs sm:text-sm text-slate-400 mt-1">سرعت هماهنگی با وب‌هوک</p>
            </div>
            <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
              <div className="text-3xl sm:text-4xl font-extrabold text-emerald-400 font-mono">۰٪ جریمه</div>
              <p className="text-xs sm:text-sm text-slate-400 mt-1">پیشگیری از کسری موجودی</p>
            </div>
            <div className="p-4 rounded-xl bg-slate-800/60 border border-slate-700/60">
              <div className="text-3xl sm:text-4xl font-extrabold text-purple-400 font-mono">چندکاناله</div>
              <p className="text-xs sm:text-sm text-slate-400 mt-1">دیجی‌کالا، باسلام و سایت</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Highlights */}
      <section className="py-12 border-b border-slate-800 bg-slate-900/40">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8">
            <h3 className="text-lg sm:text-xl font-bold text-white">مزیت‌های محوری سامانه کورسل</h3>
            <p className="text-xs sm:text-sm text-slate-400 mt-1">چرا کورسل ستون فقرات فروش آنلاین چندکاناله است؟</p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3.5">
            {highlights.map((h, i) => (
              <div key={i} className="p-3.5 rounded-xl bg-slate-800/60 border border-slate-700/60 flex items-start gap-2.5 hover:border-teal-500/30 transition-colors">
                <span className="w-5 h-5 rounded-full bg-teal-500/20 text-teal-400 flex items-center justify-center shrink-0 mt-0.5 text-xs font-bold">✓</span>
                <span className="text-xs sm:text-sm text-slate-300 leading-relaxed">{h}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Problem vs Solution */}
      <section className="py-16 border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">چرا آنلاین‌شاپ‌ها به کورسل نیاز دارند؟</h2>
            <p className="text-slate-400 max-w-xl mx-auto text-sm sm:text-base">
              فروش چند کاناله بدون اتوماسیون هوشمند، سریعاً به کابوسی پر از جریمه و خطای محاسباتی تبدیل می‌شود.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="p-6 sm:p-8 rounded-2xl bg-red-950/20 border border-red-900/40">
              <div className="flex items-center gap-3 text-red-400 font-bold text-lg mb-4">
                <span className="w-8 h-8 rounded-lg bg-red-500/20 flex items-center justify-center text-red-400">✕</span>
                <span>چالش‌های روش‌های دستی و سنتی</span>
              </div>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-start gap-2">
                  <span className="text-red-400 font-bold">•</span>
                  <span>لغو سفارش در دیجی‌کالا به‌دلیل اتمام موجودی و تحمیل جریمه‌های سنگین</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-400 font-bold">•</span>
                  <span>صرف روزانه چند ساعت وقت برای باز کردن پنل‌ها و تغییر دستی تک‌تک تنوع‌ها</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-400 font-bold">•</span>
                  <span>خطای قیمت‌گذاری و عدم پوشش کمیسیون‌های متغیر پلتفرم‌ها در نوسان نرخ کالاها</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-red-400 font-bold">•</span>
                  <span>سردرگمی تیم در انبارگردانی و مغایرت دائمی موجودی فیزیکی با آمار سایت</span>
                </li>
              </ul>
            </div>

            <div className="p-6 sm:p-8 rounded-2xl bg-teal-950/20 border border-teal-800/40">
              <div className="flex items-center gap-3 text-teal-400 font-bold text-lg mb-4">
                <span className="w-8 h-8 rounded-lg bg-teal-500/20 flex items-center justify-center text-teal-400">✓</span>
                <span>راهکار یکپارچه سامانه کورسل</span>
              </div>
              <ul className="space-y-3 text-sm text-slate-300">
                <li className="flex items-start gap-2">
                  <span className="text-teal-400 font-bold">•</span>
                  <span>کسر خودکار و ثانیه‌ای موجودی از تمام فروشگاه‌ها به محض ثبت سفارش در هر کانال</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-teal-400 font-bold">•</span>
                  <span>قیمت‌گذاری درصدی هوشمند؛ تنظیم یک‌باره قیمت پایه و اعمال خودکار به دیجی‌کالا و باسلام</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-teal-400 font-bold">•</span>
                  <span>انبارگردانی آسان؛ بارگذاری فایل اکسل و ثبت آنی موجودی هزاران کالا با یک کلیک</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-teal-400 font-bold">•</span>
                  <span>صف‌های پردازشی مقاوم (BullMQ) با قابلیت بازیابی در زمان اختلال اینترنت</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Modules Tabs */}
      <section className="py-16 bg-slate-900/60 border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">ماژول‌ها و قابلیت‌های فنی کورسل</h2>
            <p className="text-slate-400 text-sm sm:text-base">بررسی عمیق‌تر امکاناتی که در این ۷ ماه ساخته شد</p>
          </div>

          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {modules.map((m) => (
              <button
                key={m.id}
                onClick={() => setActiveTab(m.id)}
                className={`px-4 py-2.5 rounded-xl text-sm font-medium transition-all ${
                  activeTab === m.id
                    ? "bg-teal-500 text-slate-950 font-bold shadow-lg shadow-teal-500/20 scale-105"
                    : "bg-slate-800 text-slate-300 hover:bg-slate-700 border border-slate-700"
                }`}
              >
                {m.label}
              </button>
            ))}
          </div>

          {modules
            .filter((m) => m.id === activeTab)
            .map((mod) => (
              <div key={mod.id} className="p-6 sm:p-10 rounded-2xl bg-slate-800/80 border border-slate-700 shadow-xl">
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                  <div>
                    <span className="text-xs text-teal-400 font-semibold uppercase tracking-wider">ماژول تخصصی</span>
                    <h3 className="text-xl sm:text-2xl font-bold text-white mt-1">{mod.title}</h3>
                  </div>
                  <span className="px-3 py-1 rounded-full bg-teal-500/20 text-teal-300 border border-teal-500/30 text-xs font-semibold">
                    {mod.badge}
                  </span>
                </div>
                <p className="text-slate-300 text-base leading-relaxed mb-6">{mod.desc}</p>
                <div className="grid sm:grid-cols-2 gap-3.5">
                  {mod.bullets.map((b, idx) => (
                    <div key={idx} className="flex items-start gap-2.5 text-sm text-slate-300 bg-slate-900/60 p-3 rounded-xl border border-slate-700/50">
                      <svg className="w-5 h-5 text-teal-400 shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{b}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </section>

      {/* Tech Stack */}
      <section className="py-16 border-b border-slate-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">معماری و پشته فناوری (Tech Stack)</h2>
            <p className="text-slate-400 text-sm sm:text-base">توسعه‌یافته بر اساس استانداردهای نرم‌افزارهای تجاری ابری</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {techStack.map((tech, i) => (
              <div key={i} className="p-5 rounded-xl bg-slate-800/60 border border-slate-700/60 hover:border-teal-500/40 transition-colors">
                <div className="text-teal-400 font-bold text-base mb-1">{tech.name}</div>
                <p className="text-slate-400 text-xs leading-relaxed">{tech.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA / Contact Section */}
      <section className="py-20 bg-gradient-to-b from-slate-900 to-slate-950 text-center">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">
            آماده‌اید فروش آنلاین خود را یکپارچه و خودکار کنید؟
          </h2>
          <p className="text-slate-400 text-base sm:text-lg mb-8 leading-relaxed">
            استودیو آلتو آماده است سامانه کورسل را متناسب با ساختار کالاها و کانال‌های فروش شما پیکربندی و راه‌اندازی کند.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8">
            <a
              href={contact.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-teal-500 hover:bg-teal-400 text-slate-950 font-bold px-8 py-4 rounded-xl text-base transition-all hover:scale-105 shadow-xl shadow-teal-500/20"
            >
              ارتباط در واتساپ و استعلام
            </a>
            <a
              href="https://t.me/altostudio_net"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-slate-800 hover:bg-slate-700 text-white font-medium px-8 py-4 rounded-xl border border-slate-700 text-base transition"
            >
              ارتباط در تلگرام (@altostudio_net)
            </a>
          </div>

          <p className="text-slate-500 text-xs sm:text-sm">
            طراحی، پیاده‌سازی و پشتیبانی فنی مستقیم توسط مهندسین استودیو آلتو
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default CoreSellPage;
